/*
 *
 * Candidate Summary page
 *
 */

import React from "react";
import { Container } from "react-bootstrap";
import { func, object, string, bool } from "prop-types";
import ScoreReportsSection from "./ScoreReportsSection";
import WorkplaceInsightsSection from "./WorkplaceInsightsSection";

const CandidateSummaryPage = ({
  candidateFirstName,
  handleDownloadPdf,
  handleViewDetailsButton,
  showWorkplaceInsightsTraits,
  tests,
  workplaceInsightsData,
  hideBaseline,
}) => (
  <Container style={{ paddingBottom: "75px" }}>
    <ScoreReportsSection
      handleDownloadPdf={handleDownloadPdf}
      handleViewDetailsButton={handleViewDetailsButton}
      tests={tests}
      hideBaseline={hideBaseline}
    />
    {workplaceInsightsData && (
      <WorkplaceInsightsSection
        candidateFirstName={candidateFirstName}
        handleDownloadPdf={handleDownloadPdf}
        showWorkplaceInsightsTraits={showWorkplaceInsightsTraits}
        workplaceInsightsData={workplaceInsightsData}
      />
    )}
  </Container>
);

CandidateSummaryPage.propTypes = {
  candidateFirstName: string,
  handleDownloadPdf: func.isRequired,
  handleViewDetailsButton: func.isRequired,
  showWorkplaceInsightsTraits: bool,
  tests: object,
  workplaceInsightsData: object,
  hideBaseline: bool,
};

export default CandidateSummaryPage;
